/* Rail de produits suggérés : on glisse vers la droite, la suite se charge toute seule.
 *
 * Une grille de six affiches dit « voilà six affiches ». Un rail dit « il y en a d'autres »,
 * et c'est vrai : la collection en compte des centaines. Le geste de glisser coûte moins
 * qu'un clic vers une page de collection, et il ne fait pas quitter la page en cours.
 *
 * Les pages suivantes arrivent en HTML depuis la vue `rail` (templates/collection.rail
 * .liquid), pas en JSON : la carte produit est un snippet, la réécrire ici en ferait une
 * seconde version qui finirait par diverger de la vraie.
 */
(function () {
  "use strict";

  /* Deux sections chargent ce fichier (rail de reco, grille Tendances). Le navigateur ne
     dédoublonne pas deux <script src> identiques : sans ce verrou, la pagination du rail
     s'armerait deux fois et chaque glissement chargerait la page suivante en double. */
  if (window.__recoRailPret) return;
  window.__recoRailPret = true;

  var rails = [].slice.call(document.querySelectorAll("[data-rail]"));
  /* Le tri sert aussi à des blocs qui ne défilent pas : une grille porte `data-pop-grid` et
     reçoit le même classement, sans la pagination. « Toutes les suggestions du site » veut
     dire toutes, pas seulement celles qui se glissent. */
  var grilles = [].slice.call(document.querySelectorAll("[data-pop-grid]"));
  if (!rails.length && !grilles.length) return;
  var source = rails[0] || grilles[0];

  /* Ventes puis vues, comme partout où l'on contrôle le rendu. La collection arrive déjà
     triée « meilleures ventes » par Shopify, mais son calcul ignore les vues : on
     réordonne donc ce qui est affiché. Fichier absent ou illisible, on garde l'ordre reçu
     — un classement affiné ne vaut pas de casser la liste. */
  var POP = null;
  var urlPop = source.getAttribute("data-rail-pop") || "";
  var urlRepli = source.getAttribute("data-rail-pop-repli") || "";
  /* Le Studio d'abord, le fichier d'assets en secours. Le fichier fige la photo du jour où
     on l'a commité : le 31/07/2026 il datait de trois jours et ne couvrait que 120 affiches
     sur 1 322, si bien que le tri par vues ne s'appliquait qu'à 9 % du catalogue. Il reste
     là pour le jour où le Studio ne répond pas, pas comme source normale. */
  function lire(u) {
    if (!u) return Promise.reject();
    return fetch(u).then(function (r) { return r.ok ? r.json() : Promise.reject(); });
  }
  var pretPop = lire(urlPop)
    .catch(function () { return lire(urlRepli); })
    .then(function (d) { POP = (d && d.pop) || {}; })
    .catch(function () { POP = {}; });

  function trier(piste) {
    if (!POP) return;
    var cartes = [].slice.call(piste.children);
    cartes.map(function (n, i) { return { n: n, i: i }; }).sort(function (a, b) {
      var A = POP[a.n.getAttribute("data-handle")] || [0, 0];
      var B = POP[b.n.getAttribute("data-handle")] || [0, 0];
      if (B[0] !== A[0]) return B[0] - A[0];
      if (B[1] !== A[1]) return B[1] - A[1];
      return a.i - b.i;
    }).forEach(function (o) { piste.appendChild(o.n); });
  }

  /* Les grilles n'ont ni pages suivantes ni flèches : juste le classement. */
  if (grilles.length) pretPop.then(function () { grilles.forEach(trier); });

  rails.forEach(function (rail) {
    var piste = rail.querySelector("[data-rail-piste]");
    if (!piste) return;
    var handle = rail.getAttribute("data-rail-collection") || "";
    var sauf = rail.getAttribute("data-rail-sauf") || "";
    var racine = rail.getAttribute("data-rail-root") || "/";
    var page = 1;
    var fini = !handle;
    var occupe = false;

    function majFleches() {
      var g = rail.querySelector("[data-rail-prec]");
      var d = rail.querySelector("[data-rail-suiv]");
      if (g) g.disabled = piste.scrollLeft <= 4;
      /* Le bouton droit reste actif tant qu'il reste des pages : le désactiver au bout de
         la piste laisserait croire qu'on a tout vu alors qu'il reste des centaines. */
      if (d) d.disabled = fini && piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 4;
    }

    function charger() {
      if (occupe || fini) return;
      occupe = true;
      page += 1;
      var url = racine + "collections/" + encodeURIComponent(handle)
        + "?view=rail&v=1&page=" + page + (sauf ? "&sauf=" + encodeURIComponent(sauf) : "");
      /* Même précaution que le sélecteur : cette URL a pu être mise en cache avant que la
         vue existe, auquel cas elle rendrait une page collection entière. */
      /* Pas d'en-tête Accept : sur une URL de collection, Shopify négocie le contenu et
         peut renvoyer autre chose que la vue demandée. */
      fetch(url, { cache: "no-cache" })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var t = document.createElement("div");
          t.innerHTML = html;
          if (t.querySelector("[data-rail-fin]")) fini = true;
          var cartes = [].slice.call(t.children).filter(function (n) {
            return n.nodeType === 1 && !n.hasAttribute("data-rail-fin");
          });
          /* Page vide : on arrête, sinon on redemanderait sans fin. */
          if (!cartes.length) { fini = true; return; }
          /* ⛔ JAMAIS DEUX FOIS LA MEME AFFICHE. La premiere fournee vient du HTML de la
             page, qui peut etre en cache depuis des heures ; les pages suivantes arrivent
             fraiches, triees meilleures ventes VIVANTES. Entre les deux le classement
             bouge, les pages se chevauchent, et le tri par popularite collait les jumeaux
             cote a cote (panier du 02/08/2026). On filtre par handle a l'insertion : une
             page entierement connue n'arrete pas la pagination, la suivante peut apporter
             du neuf. */
          var dejaLa = {};
          [].slice.call(piste.children).forEach(function (n) {
            var h = n.getAttribute("data-handle");
            if (h) dejaLa[h] = true;
          });
          cartes = cartes.filter(function (c) {
            var h = c.getAttribute("data-handle");
            if (!h) return true;
            if (dejaLa[h]) return false;
            dejaLa[h] = true;
            return true;
          });
          cartes.forEach(function (c) { piste.appendChild(c); });
          if (cartes.length) trier(piste);
        })
        .catch(function () { fini = true; })
        .then(function () { occupe = false; majFleches(); });
    }

    /* On charge AVANT d'arriver au bout — deux largeurs d'écran d'avance — pour que le
       rail ne s'arrête jamais sous le doigt. */
    piste.addEventListener("scroll", function () {
      majFleches();
      if (piste.scrollLeft + piste.clientWidth * 3 >= piste.scrollWidth) charger();
    }, { passive: true });

    rail.addEventListener("click", function (e) {
      var b = e.target.closest("[data-rail-prec], [data-rail-suiv]");
      if (!b) return;
      var carte = piste.querySelector(":scope > *");
      var pas = carte ? carte.getBoundingClientRect().width + 16 : 240;
      var n = Math.max(1, Math.floor(piste.clientWidth / pas));
      piste.scrollBy({ left: (b.hasAttribute("data-rail-prec") ? -1 : 1) * pas * n, behavior: "smooth" });
    });

    /* Si la première page ne remplit pas la piste, il n'y a rien à faire glisser : on
       complète tout de suite plutôt que d'afficher un rail qui ne bouge pas. */
    pretPop.then(function () { trier(piste); });
    if (piste.scrollWidth <= piste.clientWidth + 4) charger();
    majFleches();
  });
})();
